import { ApiManager } from './api/ApiManager';
import { AuthManager } from './AuthManager';
import { RawDataManager } from './data/RawDataManager';
import { DataManager } from './data/DataManager';

export class FView {
    private constructor() { }

    public apiManager: ApiManager = new ApiManager();
    public authManager: AuthManager = new AuthManager();
    public rawDataManager: RawDataManager = new RawDataManager();
    public dataManager: DataManager = new DataManager();

    private static instance: FView | null = null;
    public static Get() : FView {
        if (this.instance == null) {
            this.instance = new FView();
        }
        return this.instance;
    }
}
